// extracted by mini-css-extract-plugin
export default {"section":"Statistic_section__o2lfe","btn":"Statistic_btn__Mgk0a"};